<template>
  <div class="page-container">
    <div class="settings-form">
      <h2 class="page-title">消费日志</h2>

      <!-- 统计卡片 -->
      <el-row :gutter="20" style="margin-bottom: 20px">
        <el-col :span="6">
          <el-card shadow="hover">
            <template #header>今日消耗</template>
            <div class="stat-number" :class="stats.today_cost > 0 ? 'text-danger' : ''">
              {{ stats.today_cost }} 点
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover">
            <template #header>本月消耗</template>
            <div class="stat-number" :class="stats.month_cost > 0 ? 'text-warning' : ''">
              {{ stats.month_cost }} 点
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover">
            <template #header>累计消耗</template>
            <div class="stat-number">{{ stats.total_cost }} 点</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover">
            <template #header>剩余点数</template>
            <div class="stat-number text-success">{{ stats.balance }}</div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 筛选条件 -->
      <div class="search-bar">
        <el-select v-model="filter.module" placeholder="模块筛选" clearable style="width: 150px; margin-right: 10px">
          <el-option label="全部模块" value="" />
          <el-option label="文章创作" value="article" />
          <el-option label="绿书创作" value="greenbook" />
          <el-option label="爆文改写" value="rewrite" />
          <el-option label="下拉词库" value="keyword" />
        </el-select>

        <el-select v-model="filter.action_type" placeholder="操作类型" clearable style="width: 160px; margin-right: 10px">
          <el-option label="全部类型" value="" />
          <el-option label="文章生成" value="article_generate" />
          <el-option label="标题生成" value="title_generate" />
          <el-option label="内容改写" value="content_rewrite" />
          <el-option label="关键词生成" value="keyword_generate" />
        </el-select>

        <el-date-picker v-model="filter.date_range" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" format="YYYY-MM-DD" value-format="YYYY-MM-DD" style="margin-right: 10px" />

        <el-button type="primary" @click="fetchLogs">
          <el-icon><Search /></el-icon> 查询
        </el-button>
        <el-button @click="resetFilter">重置</el-button>
      </div>

      <!-- 日志列表 -->
      <el-table :data="logList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
        <el-table-column label="模块" width="100">
          <template #default="{ row }">
            <el-tag :type="getModuleTag(row.module)" size="small">
              {{ getModuleText(row.module) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作类型" width="110">
          <template #default="{ row }">
            {{ getActionText(row.action_type) }}
          </template>
        </el-table-column>
        <el-table-column prop="cost" label="消耗点数" width="100" sortable>
          <template #default="{ row }">
            <span style="color: #f56c6c; font-weight: bold">-{{ row.cost }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="balance_before" label="扣费前余额" width="110" />
        <el-table-column prop="balance_after" label="扣费后余额" width="110" />
        <el-table-column prop="related_title" label="关联标题" min-width="200" show-overflow-tooltip />
        <el-table-column prop="detail" label="详情" min-width="200" show-overflow-tooltip />
        <el-table-column prop="create_time" label="时间" width="170" sortable />
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
          :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
          @size-change="fetchLogs" @current-change="fetchLogs" />
      </div>
    </div>
  </div>
</template>

<script>
import { Search } from '@element-plus/icons-vue'
import axios from 'axios'
import Cookies from 'js-cookie'
import config from '@/config.js'

export default {
  name: 'ConsumptionLog',
  components: { Search },
  data() {
    const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
    return {
      userInfo,
      loading: false,
      logList: [],
      stats: {
        today_cost: '0.00',
        month_cost: '0.00',
        total_cost: '0.00',
        balance: '加载中...'
      },
      filter: {
        module: '',
        action_type: '',
        date_range: null
      },
      pagination: {
        page: 1,
        pageSize: 15,
        total: 0
      }
    }
  },
  computed: {},
  mounted() {
    this.fetchStats()
    this.fetchLogs()
  },
  methods: {
    async fetchStats() {
      try {
        const { data } = await axios.post(`${config.BASE_URL}/shop/api/consumption_log_api.php`, {
          action: 'stats',
          store_id: this.userInfo.id
        })
        if (!data.error) {
          this.stats = {
            today_cost: data.today_cost || '0.00',
            month_cost: data.month_cost || '0.00',
            total_cost: data.total_cost || '0.00',
            balance: data.balance || '0.00',
            module_stats: data.module_stats || []
          }
        }
      } catch (e) {
        console.error('获取统计数据失败', e)
      }
    },
    async fetchLogs() {
      this.loading = true
      try {
        const params = {
          action: 'list',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize,
          module: this.filter.module,
          action_type: this.filter.action_type
        }
        if (this.filter.date_range && this.filter.date_range.length === 2) {
          params.date_from = this.filter.date_range[0]
          params.date_to = this.filter.date_range[1]
        }
        const { data } = await axios.post(`${config.BASE_URL}/shop/api/consumption_log_api.php`, params)
        if (!data.error) {
          this.logList = data.data || []
          this.pagination.total = data.pagination?.total || 0
          this.pagination.page = data.pagination?.page || 1
        }
      } catch (e) {
        console.error('获取日志失败', e)
      } finally {
        this.loading = false
      }
    },
    resetFilter() {
      this.filter = { module: '', action_type: '', date_range: null }
      this.pagination.page = 1
      this.fetchLogs()
      this.fetchStats()
    },
    getModuleTag(module) {
      const map = { article: '', greenbook: 'success', rewrite: 'warning', keyword: 'danger' }
      return map[module] || 'info'
    },
    getModuleText(module) {
      const map = { article: '文章创作', greenbook: '绿书创作', rewrite: '爆文改写', keyword: '下拉词库' }
      return map[module] || module
    },
    getActionText(type) {
      const map = {
        article_generate: '文章生成',
        title_generate: '标题生成',
        content_rewrite: '内容改写',
        keyword_generate: '关键词生成'
      }
      return map[type] || type
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 20px;
}
.page-title {
  font-size: 22px;
  margin-bottom: 20px;
  color: #303133;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.stat-number {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}
.text-danger {
  color: #f56c6c;
}
.text-warning {
  color: #e6a23c;
}
.text-success {
  color: #67c23a;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
